export default {
    steam_link_success: "绑定成功",
    steam_unlink_success: "解绑成功",
    steam_linked: "已绑定",
};
